<template>
  <div class="gs-app gm-broadcast-categories-catalog">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="flex mb-4 mx-4 gm-broadcast-categories-catalog__shell">
      <div class="w-full gm-broadcast-categories-catalog__workspace">
        <navigation-tabs
          class="gm-nav-sequences-tabs absolute"
          :nav_tabs="navTabs"
        />
        <server-table 
          :key="tableKey"
          class="text-center groovemail-broadcast-cat-table gs-refresh-controls"
          ref="serverTable"
          url="/get-campaign-tags"
          tableRef="broadcastCatTable"
          tableTitle="frontend_groovemail_broadcast_categories_header"
          addNewBtnText="frontend_groovemail_adminsetting_create_new_category"
          :slotData="broadcastCategorySlotData"
          :tableColumns="broadcast_cat_table_columns"
          :tableOptions="broadcast_cat_table_options"
          :emptyStateData="emptyStateData"
          @addNewData="createNewCategory"
          @loaded="hideLoader()"
          @loading="showLoader()"
        />
        
      </div>
    </div>

    <gs-named-modal class="gs-refresh-controls"
      name="create-campaign-category-modal"
      :title="
        categoryId
          ? $t('frontend_groovemail_mail_category_upadate_cat')
          : currentCategory
          ? $t('frontend_groovemail_clone_category')
          : $t('frontend_new_category')
      "
    >
      <div class="p-6">
        <BroadcastCategory
          :catId="categoryId"
          :category="currentCategory"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
          @fetchBroadcastCategories="fetchBroadcastCategories"
          @closeCreateBroadcastCatModal="closeCreateCampaignCatModal"
        />
      </div>
    </gs-named-modal>

    <gs-named-modal class="gs-refresh-controls"
      id="broadcasts-listing-modal"
      name="broadcasts-listing-modal"
      width="100%"
      :title="$t('frontend_groovemail_components_pricepoint_sidebar_broadcasts')"
    >
      <VuePerfectScrollbar>
          <server-table
            class="text-center groovemail-broadcasts-table"
            ref="serverTable"
            :url="broadcastsUrl"
            tableRef="broadcastsTable"
            :slotData="broadcastListingTableSlotData"
            :tableColumns="broadcastsColumns"
            :tableOptions="broadcastsOptions"
            @loaded="hideLoader()"
            @loading="showLoader()"
          >
          </server-table>
      </VuePerfectScrollbar>
    </gs-named-modal>


    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-delete-broadcast-cat`"
      :name="`confirmation-delete-broadcast-cat`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_delete_email_template_broadcast_category')"
      @confirm="deleteCategory"
      @close="closeDeleteCategoryModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import themeConfig from '@/theme/themeConfig.js';
import NavigationTabs from '@/components/navigation-tabs.vue';
import BroadcastCategory from '@/components/broadcast-category.vue';
import showAlert from '@/components/sweet-alert-popup.js';

export default {
  name: 'BroadcastCategories',
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_broadcast_categories_header'),
    };
  },
  data() {
    return {
      categoryId: null,
      currentCategory: '',
      tableKey: 0,
      broadcastsTableKey: 2,
      navTabs: [
        {
          tabName: 'frontend_groovemail_email_template_categories_header',
          tabRoute: 'EmailTemplateCategories',
        },
        {
          tabName: 'frontend_groovemail_broadcast_categories_header',
          tabRoute: 'BroadcastCategories',
        },
      ],
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      broadcast_cat_table_columns: [
        'name',
        'campaign_count',
        'created_at',
        'actions',
      ],
      broadcast_cat_table_options: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['name'],
        sortable: ['name', 'created_at'],
        headings: {
          name: () => this.$t('frontend_groovemail_adminsetting_name'),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          campaign_count: () =>
            this.$t(
              'frontend_groovemail_components_pricepoint_sidebar_broadcasts'
            ),
        },
        requestFunction(data) {
          const self = this;
          if (!(data && data.orderBy)) {
            data.orderBy = 'created_at';
            data.ascending = 0;
          }
          return axios
            .get(self.url, {
              params: data,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.total,
          };
        },
      },
      broadcastsUrl: '',
      broadcastsColumns: ['name', 'method', 'created_at'],
      broadcastsOptions: {
        perPage: 5,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [5],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: [],
        sortable: [],
        headings: {
          name: () => this.$t('frontend_groovemail_adminsetting_name'),
          method: () => this.$t('frontend_type'),
          created_at: () => this.$t('frontend_groovemail_created_at'),
        },
        requestFunction(data) {
          return axios
            .get(this.url, {
              params: data,
            })
            .catch((e) => {
              this.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          return {
            data: data?.data ? data?.data : [],
            count: data?.meta?.total ? data?.meta?.total : 0,
          };
        },
      },
      emptyStateData: {
        emptyStateHeading: 'frontend_groovemail_broadcast_categories_header',
        emptyStateSubHeading: 'frontend_groovemail_broadcast_categories_have_no_data',
        emptyStateBtnText: 'frontend_groovemail_adminsetting_create_new_category',
      },
    };
  },

  computed: {
    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },

    broadcastCategorySlotData() {
      return [
        {
          slotName: 'category_name',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.category_name
              ? props.row.category_name
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'campaign_count',
          slotType: 'clickable',
          classes: () => '',
          callback: (props) => this.fetchBroadcasts(props.row),
          defaultValue: 0,
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => true,
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: () => true,
              callback: (props) => this.updateCategory(props.row),
            },
            {
              id: 1,
              name: () => this.$t('frontend_clone'),
              conditions: () => true,
              callback: (props) => this.cloneCategory(props.row),
            },
            {
              id: 2,
              name: () => this.$t('frontend_delete'),
              conditions: () => true,
              callback: (props) => this.deleteCategoryModal(props.row),
            },
          ],
        },
      ];
    },

    broadcastListingTableSlotData() {
      return [
        {
          slotName: 'name',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.name
              ? props.row.name
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'method',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.method
              ? props.row.method
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        }
      ];
    },
  },

  components: {
    NavigationTabs,
    BroadcastCategory,
    VuePerfectScrollbar,
    ServerTable
  },

  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    createNewCategory() {
      this.categoryId = null;
      this.currentCategory = '';
      this.openCreateCampaignCatModal();
    },

    openCreateCampaignCatModal() {
      this.$root.$emit('modal-open', 'create-campaign-category-modal');
    },

    closeCreateCampaignCatModal() {
      this.$root.$emit('modal-close', 'create-campaign-category-modal');
    },


    async fetchBroadcastCategories() {
      this.showLoader();

      try {
        if (this.$refs.serverTable?.$refs?.broadcastCatTable) {
          const catData = await axios.get(
            `/get-campaign-tags?query=${
              this.$refs.serverTable?.$refs?.broadcastCatTable.filteredQuery}
              &limit=${this.broadcast_cat_table_options?.perPage}
              &page=${this.$refs.serverTable?.$refs?.broadcastCatTable.Page}
              &ascending=0&byColumn=0`
          );
          
          await this.$refs.serverTable?.updateData(catData?.data?.data, catData?.data?.total);
        } else {
          // refresh the table
          this.tableKey += 1;
        }
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response.data.error);
      }
      
      this.hideLoader();
    },

    updateCategory(category) {
      this.categoryId = category.id;
      this.currentCategory = category.name;
      this.openCreateCampaignCatModal();
    },

    cloneCategory(category) {
      this.categoryId = null;
      this.currentCategory = `${category.name} [ ${this.$t('frontend_copy').toUpperCase()} ]`;
      this.openCreateCampaignCatModal();
    },

    // open delete category modal
    async deleteCategoryModal(category) {
      // set the category id
      this.categoryId = category.id;

      // open the modal
      this.$refs[`confirmation-delete-broadcast-cat`].open();
    },

    // close delete category modal
    closeDeleteCategoryModal() {
      // reset the category id
      this.categoryId = null;

      // close the modal
      this.$refs[`confirmation-delete-broadcast-cat`].close();
    },

    // delete category
    async deleteCategory() {
      try {
        // show loader
        this.showLoader();

        // delete the category
        await axios.delete(`/campaign-tags/${this.categoryId}`);
        const catData = await axios.get(`/get-campaign-tags?query=${this.$refs.serverTable.$refs.broadcastCatTable.filteredQuery}&limit=${this.broadcast_cat_table_options.perPage}&page=${this.$refs.serverTable.$refs.broadcastCatTable.Page}&ascending=0&byColumn=0`
        );

        // update the table data with the new data
        this.$refs.serverTable.updateData(catData?.data?.data, catData?.data?.total);

        // hide the loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response.data.error);
      }
    },

    fetchBroadcasts(category) {
      this.broadcastsUrl = `/campaign/by/tags/${category.id}`;
      this.$root.$emit('modal-open', 'broadcasts-listing-modal');
    },
  },
};
</script>

<style lang="scss">
.groovemail-broadcast-cat-table {
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(1) {
      width: 35% !important;
      word-break: break-word;
    }
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3) {
      width: 25% !important;
      word-break: break-word;
    }
  }
}

.groovemail-broadcasts-table {
  .VueTables--server {
    padding: 24px;
    .table-responsive {
      background: #ffffff !important;
      .VueTables__table {
        th:last-child span {
          display: block !important;
        }
        border: 1px solid #ccc !important;
      }
    }
    td {
      word-break: break-all;
    }
    .VuePagination {
      margin-bottom: 10px;
    }
    .VueTables__limit-field {
      display: none !important;
    }
  }
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(1),
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3) {
      width: 33% !important;
      word-break: break-word;
    }
  }
}
</style>

<style scoped>
.gm-broadcast-categories-catalog {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-broadcast-categories-catalog__shell {
  margin: 0;
}

.gm-broadcast-categories-catalog__workspace {
  min-width: 0;
  padding: 20px 24px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-broadcast-categories-catalog >>> .VueTables__table,
.gm-broadcast-categories-catalog >>> .VueTables__table th,
.gm-broadcast-categories-catalog >>> .VueTables__table td {
  border-color: var(--gs-border);
}

@media (max-width: 640px) {
  .gm-broadcast-categories-catalog { padding: 18px 12px 32px; }
  .gm-broadcast-categories-catalog__workspace { padding: 16px; }
}
</style>
